// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"eO-z","upvoteIcon":"fO-z","downvoteIcon":"gO-z","feedbackIcon":"hO-z"};